<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{subrentalOutputModel.inventoryOutputId}}" class="head col-12 col-lg-12">

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalOutputModel.branchName}}</p>

                  <!--Nombre Salida Subalquiler -->
                  <p id="nombre-salida-subalquiler-{{subrentalOutputModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'SALIDA SUBALQUILER Nro.'+ subrentalOutputModel.consecutive}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion'
                    | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalOutputModel.address}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalOutputModel.phone}}</p>

                  <!-- Fecha Salida -->
                  <label id="t-fecha-salida-subalquiler-{{subrentalOutputModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-salida-subalquiler' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-salida-subalquiler-{{subrentalOutputModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{subrentalOutputModel.dateOutput | date: 'dd/MM/yyyy'}}</p>

                  <!-- Documento Entrega  -->
                  <label id="t-documento-entrega-{{subrentalOutputModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-documento-entrega' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="documento-entrega-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalOutputModel.deliveryDocument}}</p>

                  <!-- Transportador-->
                  <label id="t-transportador-{{subrentalOutputModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-transportador' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="transportador-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{ subrentalOutputModel.transporterName }}</p>

                  <!-- Vehículo (Placa)-->
                  <label id="t-vehiculo-{{subrentalOutputModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-vehiculo' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="vehiculo-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalOutputModel.plate}}</p>

                  <!-- Valor Transporte -->
                  <label id="t-valor-transporte-{{subrentalOutputModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-valor-transporte' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-transporte-{{subrentalOutputModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalOutputModel.transportValue | currency}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-salida-subalquiler-{{subrentalOutputModel.inventoryOutputId}}"
                  [columns]="columns" [data]="subrentalOutputModel.subrentalOutputDetails" [idMap]="idMap"
                  [documentId]="subrentalOutputModel.inventoryOutputId" [footerVisible]="true" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{subrentalOutputModel.inventoryOutputId}}" class="foot mt-1 container-observations">
                <label id="t-observacion-salida-subalq-{{subrentalOutputModel.inventoryOutputId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="subrentalOutputModel.observation">{{'t-observacion-salida-subalq' |
                  formatLabelPipe : elementsLabel}}</label>

                <p id="observacion-salida-subalquiler-{{subrentalOutputModel.inventoryOutputId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="subrentalOutputModel.observation">
                  {{subrentalOutputModel.observation}}</p>

                <!-- Firma Revisado-->
                <p id="linea-firma-revisado-{{subrentalOutputModel.inventoryOutputId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-revisado-{{subrentalOutputModel.inventoryOutputId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-revisado' | formatLabelPipe :
                  elementsLabel}}</label>

                <!-- Firma Recibe-->
                <p id="linea-firma-recibe-{{subrentalOutputModel.inventoryOutputId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-recibe-{{subrentalOutputModel.inventoryOutputId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-recibe' | formatLabelPipe :
                  elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>